export enum CustomFilterType {
  All = 'All',
  NewSubscriptions = 'New Subscription',
  Renewals = 'Renewal',
  Cancellations = 'Cancellation',
  Expirations = 'Expiration',
  Refunded = 'Refunded'
}



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/models/CustomFilterType.ts